<div
  class="mtm-file-download-upload-preview d-flex flex-column m-auto"
  [style.max-width]="'540px'"
  [style.width]="'100%'">
  <div class="d-flex align-items-center p-2 m-auto _600 w-100" [style.border-bottom]="'1px solid #ccc'">
    <span class="d-inlone-block m-auto">{{ 'uploadInProgress' | translate }}</span>
  </div>
  @for (file of fileData; track file) {
    <div class="d-flex p-3">
      <div class="mtm-file-download-upload-preview-icon">
        <img
          type="image/svg+xml"
          [src]="file | fileTypeIcon"
          [alt]="file?.displayName || 'File icon'"
          (error)="onImageError($event)" />
      </div>
      <div class="mtm-file-download-upload-preview-meta flex-fill d-flex flex-column">
        <div class="d-flex align-items-center pt-1">
          <div class="filename me-auto flex-fill pt-1 pb-1" fileNameDisplay [fileName]="file?.displayName"> </div>
          <div class="progress-in-text ms-auto pt-1 pb-1">{{ file?.progress }}%</div>
        </div>
        <div class="mtm-file-download-upload-preview-progress mt-2">
          <div class="progress-background" [style.width]="`${file?.progress || 0}%`"></div>
        </div>
      </div>
    </div>
  }
</div>
